import { render, staticRenderFns } from "./TheHeader.component.vue?vue&type=template&id=61afcfee&scoped=true"
import script from "./TheHeader.component.vue?vue&type=script&lang=js"
export * from "./TheHeader.component.vue?vue&type=script&lang=js"
import style0 from "./TheHeader.component.vue?vue&type=style&index=0&id=61afcfee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61afcfee",
  null
  
)

export default component.exports